import { render } from "./AndamentoCab.vue?vue&type=template&id=79671d7e&scoped=true"
import script from "./AndamentoCab.vue?vue&type=script&lang=js"
export * from "./AndamentoCab.vue?vue&type=script&lang=js"

import "./AndamentoCab.vue?vue&type=style&index=0&id=79671d7e&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79671d7e"]])

export default __exports__